<template>
  <v-container fluid class="mx-auto mt-0 mb-3">
    <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex d-inline' : ''">
      <div>
        <div class="d-flex d-inline">
          <div class="title ml-n1 mt-n3">{{ $t("currentMembership") }}</div>
          <div
              class="ml-1 mt-n2"
              style="margin-top: 3px"
              v-if="!isFreeMembership"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on"> mdi-information-outline</v-icon>
              </template>
              <span>
                {{ $t("toolTips.currentMembershipRecurring") }}
              </span>
            </v-tooltip>
          </div>
        </div>
        <div class="mt-n1 ml-n1">
          <span class="green--text text-body-1">
            {{ $store.state.membership.name }} {{ $t("whoHas") }}
            {{ $store.state.membership.maxActiveConnections }}
            <span v-if="$store.state.membership.maxActiveConnections === 1">
              {{ $t("connection") }}
            </span>
            <span v-else>{{ $t("connections") }}</span>
            <span> {{ " (" + getMembershipFinished + ")" }}</span>
          </span>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {MembershipType} from "../../enums/membership/typeOfMembership.js";
import {getDateFormatOptions} from "@/components/connections/shared";

export default {
  data() {
    return {
      dialog: false,
      membershipSnackbar: false,
      immediateSyncsFinish: false,
      stopRecurringFinish: false,
    };
  },
  computed: {
    isFreeMembership() {
      return this.$store.state.membership.maxActiveConnections === 1 && this.$store.state.membership.name === MembershipType.HOBBY.name;
    },
    getMembershipFinished() {
      if (this.isFreeMembership) {
        return this.$t("lifeLong");
      } else {
        const date = new Date(this.$store.state.membership.finishes);
        return this.$t("until") + " " + date.toLocaleString(undefined, getDateFormatOptions(this.$store.state.user.timeZone));
      }
    }
  },
};
</script>

<style scoped></style>
